export const miscStyles = {
	lightGlassBackgroundColor: 'rgba(255, 255, 255, 0.3)',
	lightBackgroundColor: 'rgba(255, 255, 255, 0.88)',
	darkGlassBackgroundColor: 'rgba(66, 66, 66, 0.3)',
	darkBackgroundColor: 'rgba(66, 66, 66, 0.88)',
	glassBackdropFilter: 'saturate(180%) blur(18px)',
}
